export default __webpack_public_path__ + "static/datelabel-dropdown-dont-3-light-6b255c392b7d964f1369cd30b945f7e3093d24c51c58a663630c738e9215e846.png";